import { Routes } from '@angular/router';

import { ERoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const candidatesRoutes: Routes = [
  {
    path: ERoutes.CANDIDATES,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./candidates-table/candidates-table.component').then(
            (m) => m.CandidatesTableComponent
          ),
      },
      {
        path: 'card',
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./candidates-card/candidates-card.component').then(
            (m) => m.CandidatesCardComponent
          ),
      },
    ],
  },
];
